import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import InlineSVG from 'svg-inline-react';
import _ from 'lodash';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';

import classes from './NoteList.scss';
import { saveNote, deleteNote } from '../../store/modules/note';
import mergeStates from '../../helpers/mergeStates';

import icDelete from '../../assets/ic_delete.svg';
import { dateFormatLong } from '../../helpers/formats';

require('moment/locale/de');

const mapActionCreators = {
  deleteNote,
  saveNote,
};

const mapStateToProps = state => ({
  notes: state.note.notes,
  fetching: state.note.fetching,
});

class NoteList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: '',
    };
    moment.locale('de');
  }

  shouldComponentUpdate(nextProps, nextState) {
    // debugger;

    if (
      Object.keys(nextProps.notes).length !==
      Object.keys(this.props.notes).length
    ) {
      return true;
    }

    if (nextProps.fetching !== this.props.fetching) {
      return true;
    }

    if (nextState.content !== this.state.content) {
      return true;
    }

    if (!_.isEqual(this.props.notes, nextProps.notes)) {
      return true;
    }

    return true;
  }

  handleChange = event => {
    const nextState = mergeStates(event, this.state);
    this.setState(nextState);
  };

  checkSubmit = event => {
    if (event.keyCode === 13) {
      this.save();
    }
  };

  focus = () => {
    if (this.primaryInput && this.primaryInput !== null) {
      this.primaryInput.focus();
    }
  };

  save = () => {
    // console.log('saving');
    if (this.state.content.length) {
      this.props.saveNote(this.state);
      this.setState({ content: '' });
    }
    this.focus();
  };

  delete = e => {
    // console.log('deleting', e);
    this.props.deleteNote(e);
  };

  renderDate = date => {
    // we get a UTC+0 date from the server, so lets parse it as utc-date and convert it to the local timezone
    const parsed = moment(date);
    const isPast = moment()
      .subtract(1, 'months')
      .diff(parsed);

    if (isPast > 0) {
      return (
        <div>
          <span>{parsed.format(dateFormatLong)}</span>
        </div>
      );
    }

    return (
      <div>
        <span className={classes.normal}>{parsed.fromNow()}</span>
        <span className={classes.technical}>
          {parsed.format(dateFormatLong)}
        </span>
      </div>
    );
  };

  renderNotes = () => {
    const notes = [];

    const sortedNotes = _.orderBy(this.props.notes, ['created_at'], ['desc']);

    _.forOwn(sortedNotes, data => {
      if (typeof data.id !== 'undefined' && typeof data.content !== undefined) {
        notes.push(
          <div className={classes.note} key={`note_${data.id}`}>
            <div className="row">
              <span className={`col-xs-10 ${classes.noteContent}`}>
                {data.content}
                <div className={classes.noteDate}>
                  {this.renderDate(data.created_at)}
                </div>
              </span>
              <span
                className={`col-xs-2 text-right delete ${classes.delete}`}
                onClick={() => {
                  this.delete(data.id);
                }}
              >
                <InlineSVG src={icDelete} />
              </span>
            </div>
          </div>,
        );
      }
    });

    if (notes.length === 0) {
      notes.push(
        <div className={classes.emptyState} key="note_emptystate">
          Noch keine Notizen vorhanden.
          <br />
          Notizen sind nur für Sie sichtbar.
        </div>,
      );
    }

    return notes;
  };

  render() {
    return (
      <div className={`${classes.notes} ${this.props.fetching} JoyrideStep2`}>
        <div className={classes.newNote}>
          <input
            name="content"
            type="text"
            placeholder="Notiz erstellen..."
            onKeyDown={e => this.checkSubmit(e)}
            onChange={e => this.handleChange(e)}
            value={this.state.content}
            ref={input => {
              this.primaryInput = input;
            }}
          />
          <div>
            <RaisedButton
              label="Speichern"
              primary
              onClick={() => this.save()}
            />
          </div>
        </div>
        {this.renderNotes()}
      </div>
    );
  }
}

NoteList.propTypes = {
  notes: PropTypes.object.isRequired,
  fetching: PropTypes.bool.isRequired,
  saveNote: PropTypes.func.isRequired,
  deleteNote: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapActionCreators)(NoteList);



// WEBPACK FOOTER //
// ./src/components/NoteList/NoteList.js